<template>
  <div class="regulatory-contract">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'billNo'">
              <a @click="jumpToMaintain(row)" href="javascript:void(0)">{{ row[item.field] }}</a>
            </template>
            <template v-else-if="item.field === 'billStatus'">
              {{ translateBillStatus(row.billStatus) }}
            </template>
            <template v-else-if="item.field === 'approvalType'">
              {{ translateApprovalType(row.approvalType) }}
            </template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 弹窗区域 -->
    <FreezeDialog ref="freezeDialogRef" :selectData="selectData" />
    <ApplicationUnfreezingDialog ref="applicationUnfreezingDialogRef" :selectData="selectData" />
    <DischargeApplicationDialog ref="dischargeApplicationDialogRef" :selectData="selectData" />
    <FreezeTipDialog ref="freezeTipDialog" />
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import { searchFormColumns, baseColumnListDefault } from './index.js';
  import tableBtnMixin from './tableBtnMixin';
  import superviseBillApi from '@/api/park/superviseBill';
  import FreezeDialog from './components/FreezeDialog/index.vue';
  import ApplicationUnfreezingDialog from './components/ApplicationUnfreezingDialog';
  import DischargeApplicationDialog from './components/DischargeApplicationDialog';
  import FreezeTipDialog from './components/FreezeTipDialog/index.vue';
  import BASE_API from '@/api/dataBase.js';
  export default {
    mixins: [tableMixins, tableBtnMixin],
    name: 'supervisionBillList',
    data() {
      return {
        tableData: [
          {
            /* billNo: '111',
            billStatus: '01',
            contractNo: '222',
            id: '218',
            stockQuantity: 100,
            safeQuantity: 400,
            usedQuantity: 300,
            outQuantity: 200, */
          },
        ],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        menuButtonList: [], // 表格功能按钮
        query: {
          parkDepartmentNo: '',
        },
        supervisionBillStatusList: [], // 监管单状态
        contractNatureList: [], // 合同性质
        parkCompanyList: [], // 园区公司
        columnList: [],
        departList: [],
        loading: false,
        selectionList: [],
        selectData: null,
      };
    },
    computed: {
      //表单字段
      searchColumns() {
        return searchFormColumns(this);
      },
    },
    mounted() {
      this.supervisionBillStatusList = this.dictListMap.SuperviseBillStatusType;
      this.contractNatureList = this.dictListMap.SuperviseContractNature;
      this.getButtonList();
      this.getTableData();
      this.$refs.siruiTable.setPageTotal(100);
      console.log(this.userInfo.userInfo, 'userInfo');
    },
    methods: {
      // 选中复选框
      handleSelectionChange(row) {
        this.selectionList = row;
        console.log(this.selectionList, 'selectionList');
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      // 获取当前登录人所在的部门
      getDepartmentList(code) {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departList = (res.data.data.personDepartmentInfo || []).map((v) => {
              return {
                label: v.personDepartmentName,
                value: v.personDepartmentCode,
              };
            });
          } else {
            this.departList = [];
          }
        });
      },
      //获取当前列
      getColumnInfo() {
        this.columnList = baseColumnListDefault;
      },
      // 表单中事件
      changeMethod({ val, prop }) {
        console.log(val, prop, '触发');
        const selectRowData = (val && val[0]) || {};
        if (prop == 'goodsType') {
          this.query.goodsType = selectRowData.groupCategoryName;
        } else if (prop == 'pledgorName') {
          this.query.pledgorName = selectRowData.partnerZhName;
        } else if (prop == 'pledgeeName') {
          this.query.pledgeeName = selectRowData.partnerZhName;
        } else if (prop == 'relatedName') {
          this.query.relatedName = selectRowData.partnerZhName;
        } else if (prop == 'parkCompanyNo') {
          this.query.parkDepartmentNo = null;
          this.getDepartmentList(val);
        }
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 得到表格数据
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          queryLineInfoFlag: 1,
        };
        const { data } = await this.$axios.post(superviseBillApi.GET_PAGE_DATA, postData);
        this.isLoading = false;
        if (data.code == 0) {
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.tableData = data.data.records;
          this.tableData.forEach((item) => {
            item.quantity = this.quantitySum(item.collaterals);
            item.safeWeight = this.safeWeightSum(item.collaterals);
          });
        } else {
          this.$message.error('查询表格数据失败');
          this.tableData = [];
        }
      },
      quantitySum(arr) {
        let sum = 0;
        arr.forEach((item) => {
          sum = sum + item.quantity;
        });
        return sum;
      },
      safeWeightSum(arr) {
        let sum = 0;
        arr.forEach((item) => {
          sum = sum + item.safeWeight;
        });
        return sum;
      },
      // 单击单元格跳转
      jumpToMaintain(row) {
        const { id, billStatus } = row;
        const editPath = {
          path: '/park/superviseBill',
          name: 'edit',
          meta: {
            keepAlive: true,
            title: '监管单维护',
          },
          query: {
            status: 'edit',
            id,
          },
        };
        const detailPath = {
          path: '/park/superviseBill',
          name: 'supervisionBillDetail',
          meta: {
            keepAlive: true,
            title: '监管单详情',
          },
          query: {
            status: 'detail',
            id,
          },
        };
        // 01-未入库，11-审批驳回
        if (billStatus == '01' || billStatus == '11') {
          this.$router.push(editPath);
        } else {
          this.$router.push(detailPath);
        }
      },
      // 翻译监管单状态
      translateBillStatus(val) {
        return this.supervisionBillStatusList.find((item) => item.value == parseInt(val))?.label;
      },
      translateApprovalType(val) {
        if (val == undefined || val == null || val == '') return val;
        else if (val == '05') return '创建申请';
        else if (val == '02') return '手动冻结';
        else if (val == '01') return '常规';
        else if (val == '03') return '解冻申请';
        else if (val == '04') return '解押申请';
        else return val;
      },
    },
    components: {
      FreezeDialog,
      ApplicationUnfreezingDialog,
      DischargeApplicationDialog,
      FreezeTipDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
